{
  "thirdparty": {
    "expedia": {
      "legalModal": {
        "title": "Muiden matkapalveluiden varaaminen",
        "expandTitle": "Katso lisätietoja suorituskyvyttömyysvakuudesta",
        "poweredBy": "Palvelun tarjoaa"
      },
      "nonSupportedLanguageWidget": {
        "collectAvios": "Kerää Avioksia",
        "title": "Varaa hotelli kohteesta {cityName} ja kerää Avioksia",
        "description": "Katso yhteistyökumppanimme hotellitarjoukset ja kerää Avioksia, kun varaat majoituksesi etukäteen.",
        "ctaButton": "Katso hotellitarjoukset",
        "poweredBy": "Palvelun tarjoaa"
      }
    }
  },
  "navigation": {
    "hotelsAndCarRental": "Hotellit ja liikkumispalvelut"
  },
  "labels": {
    "hotelsAndCarRental": "Hotellit ja liikkumispalvelut"
  },
  "fragments": {
    "expediaHotelsLegislationModal": {
      "localSettings": {},
      "url": "/fi-fi/3939080-3939080"
    },
    "expediaHotelsLegislationModalExpanded": {
      "localSettings": {},
      "url": "/fi-fi/3939082-3939082"
    },
    "expediaHotelsImage": {
      "localSettings": {},
      "url": "/fi-fi/3940320-3940320"
    }
  }
}
